import { useState } from "react";
import { Copy, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

const SITE = "https://bds-3d-motion.emergent.host";
const MESSAGE = "Black Dog Society — face your demons, wear your story. Art-led clothing for the mind:";

export const ShareSociety = ({ title = "Bring someone with you", subtitle }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = SITE;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copied — pass it on.");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Couldn't copy the link.");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "Black Dog Society", text: MESSAGE, url: shareUrl });
      } catch {
        /* user dismissed */
      }
    } else {
      copy();
    }
  };

  const links = [
    { label: "X", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(MESSAGE)}&url=${encodeURIComponent(shareUrl)}` },
    { label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(MESSAGE + " " + shareUrl)}` },
    { label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}` },
  ];

  return (
    <div data-testid="share-society" className="border border-bds-border bg-bds-surface p-6 md:p-7 text-left">
      <p className="font-mono-bds text-[11px] uppercase tracking-[0.25em] text-bds-accent mb-2">Share the Society</p>
      <h3 className="font-serif-display text-2xl md:text-3xl mb-1">{title}</h3>
      <p className="font-grotesk text-sm text-bds-muted mb-5">
        {subtitle || "Someone you know is fighting quietly too. Send them in."}
      </p>
      <div className="flex flex-wrap items-center gap-3">
        <button
          onClick={copy}
          data-testid="share-copy-btn"
          className="inline-flex items-center gap-2 font-mono-bds text-xs uppercase tracking-[0.15em] px-4 py-3 border border-bds-border hover:bg-bds-fg hover:text-bds-bg transition-colors"
        >
          {copied ? <Check size={14} /> : <Copy size={14} />}
          {copied ? "Copied" : "Copy link"}
        </button>
        <button
          onClick={nativeShare}
          data-testid="share-native-btn"
          className="inline-flex items-center gap-2 font-mono-bds text-xs uppercase tracking-[0.15em] px-4 py-3 border border-bds-border hover:bg-bds-fg hover:text-bds-bg transition-colors"
        >
          <Share2 size={14} /> Share
        </button>
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`share-${l.label.toLowerCase()}`}
            className="font-mono-bds text-xs uppercase tracking-[0.15em] px-4 py-3 border border-bds-border hover:bg-bds-accent hover:text-bds-cream hover:border-bds-accent transition-colors"
          >
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
};
